
<div mat-dialog-actions class="close-btn">
  <button  (click)="CloseDialog()" class="icon-k-close" *ngIf="DontColse"></button>
</div>

<div [innerHtml]="html"></div>
<div mat-dialog-actions align="end">
</div>
